<!-- 设备保养记录 -->
<style>
.baoyangxianginput {
  width: 1.25rem;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/repair/bill/resumeByRepairBillRecordPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            {{ $attrs.repairRecord.equipmentName }}
          </el-form-item>
          <el-form-item :label="$t('dangyueleijiweixiucishu')" label-width="230px">
            {{ yt.total }} </el-form-item
          ><br />
          <el-form-item :label="$t('xuanzeyuefen')">
            <yi_time_input format="yyyy-MM" :type="'month'" :time.sync="yt.conditions.particularYearAndMonth"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 3 || scope.row.status == 4">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('weixiuxiangqing', scope.row, 'w2');
                getRepairMethodItem(scope.row);
              "
            >
              {{ $t('weixiuxiangqing') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- "维修详情"弹窗-状态为成功 -->
      <template v-if="yt.editObj.action == 'weixiuxiangqing' && yt.editObj.status != 4">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <!-- 备注 -->
            <el-form-item :label="$t('beizhu')" label-width="280px" size="mini">
              {{ yt.editObj.remark }}
              <!-- <el-input style="width: 300px;" type="textarea" v-model="yt.editObj.remark" disabled></el-input> --> </el-form-item
            ><br />
            <el-form-item :label="$t('weixiufangfa')" label-width="310px"> </el-form-item>
            <el-form-item :label="$t('weixiushuoming')" label-width="210px"> </el-form-item>
          </el-form>
          <el-form>
            <el-form-item v-for="(item, index) in repairMethodItemList" label-width="230px" size="mini">
              <el-col :span="0.8">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :value="item.methodName" />
              </el-col>
              <el-col :span="6">&nbsp;</el-col>
              <el-col :span="7">
                <el-input class="baoyangxianginput" :value="item.remark" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="5">&nbsp;</el-col>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <!-- "维修详情"- 维修失败弹窗 -->
      <template v-if="yt.editObj.action == 'weixiuxiangqing' && yt.editObj.status == 4">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <!-- 备注 -->
            <el-form-item :label="$t('beizhu')" label-width="230px" size="mini">
              <el-input type="textarea" disabled v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import maintenance_item from '@@/pages/web/equipment/maintenance/maintenance_item';
export default {
  name: 'web_equipment_resume_repair_record',
  components: {
    maintenance_item
  },
  data() {
    return {
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      repairMethod: [],
      repairMethodItemList: [],
      columns: [
        {
          label: 'weixiudanhao',
          prop: 'no',
          fixed: 'left',
          width: 180
        },
        {
          label: 'baoxiushijian',
          prop: 'createTime',
          type: 'time',
          width: 230
        },
        {
          label: 'baoxiuren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'guzhangmiaoshu',
          prop: 'description'
        },
        {
          label: 'weixiuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('daichuli')
            },
            2: {
              color: '#E6A23C',
              text: this.$t('weixiuzhong')
            },
            3: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            },
            4: {
              color: '#969696',
              text: this.$t('shibai')
            }
          }
        },
        {
          label: 'jinjichengdu',
          prop: 'level',
          type: 'dictionary',
          key: 'EQUIPMENT_REPAIR_LEVEL',
          width: 150
        },
        {
          label: 'weixiuren',
          prop: 'repairByObject.nickname'
        },
        {
          label: 'weixiukaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'weixiujieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      //设备
      this.yt.conditions.equipmentId = this.$attrs.repairRecord.equipmentId;
      this.setDefaultTime();
      this.yt.get(1);
      this.getRepairMethod();
    }, 300);
  },
  watch: {
    'yt.editObj.action': {
      handler(n) {
        if (n === 'wanchengweixiu') {
          this.$set(this.yt.editObj, 'methodList', [
            {
              label: '',
              id: 0
            }
          ]);
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    //重置按钮
    reset() {
      this.setDefaultTime();
      this.yt.get(1);
    },
    // 请求查询客户数据字典中的维修方法项
    async getRepairMethod() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: 'SBWXFF'
        }
      });
      this.repairMethod = response.data;
    },
    // 开始维修
    startRepair(editObj) {
      this.http
        .post('/web/equipment/repair/bill/start', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    // 添加维修方法项
    addItem() {
      this.yt.editObj.methodList.push({
        method: '',
        remark: ''
      });
    },
    // 删除维修方法项
    deleteItem(key) {
      this.yt.editObj.methodList = this.yt.editObj.methodList.filter((item, index) => {
        return index !== key;
      });
    },
    // 根据维修记录id查询已成功完成维修的维修详情
    async getRepairMethodItem(obj) {
      let response = await this.http.get('/web/equipment/repair/bill/listMethod', {
        params: {
          repairId: obj.id
        }
      });
      this.repairMethodItemList = response.data;
      console.log('itemList:', this.repairMethodItemList);
    },
    setDefaultTime() {
      var currentMonthDate = new Date();
      currentMonthDate.setDate(1);
      currentMonthDate.setHours(0);
      currentMonthDate.setSeconds(0);
      currentMonthDate.setMinutes(0);
      currentMonthDate.setMilliseconds(0);
      this.yt.conditions.particularYearAndMonth = currentMonthDate.getTime();
    }
  }
};
</script>
